import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

const aestheticsConfig: ServicePageConfig = {
  title: 'Aesthetics & Anti-Aging - FGA Prestige',
  description: 'Tailored access to leading clinics and specialists for beauty, wellness, and rejuvenation.',
  slug: 'aesthetics-anti-aging',
  heroImage: '/Member Services/AESTHETICS & ANTI-AGING/hero.png',
  serviceName: 'AESTHETICS & ANTI-AGING',
  whySectionA: {
    title: 'Elevate Your Wellness Journey',
    content: 'Through our partnership with ReproCELL, FGA Prestige empowers clients with privileged access to one of the most advanced anti-aging platforms available worldwide—delivering exclusive treatments that were once the province of elite research institutions. From anti-aging facials and revitalization protocols to bespoke wellness programs, each experience is designed to unlock confidence, youthfulness, and longevity.',
    image: '/Member Services/AESTHETICS & ANTI-AGING/body/1.png',
    imageAlt: 'Luxury wellness experience'
  },
  whySectionB: {
    title: 'Key Benefits for Our Clients',
    benefits: [
      {
        title: 'Superior Anti-Aging Effects',
        description: 'IPS exosomes have been clinically shown to restore youthful vitality at the cellular level, stimulating collagen production, minimizing wrinkles, and boosting skin regeneration for visibly firmer, more radiant skin.'
      },
      {
        title: 'Cutting-Edge Safety and Purity',
        description: 'Stringent donor screening, GMP-certified manufacturing, and advanced purification ensure the highest levels of safety and effectiveness—setting a new benchmark in luxury aesthetics.'
      },
      {
        title: 'Personalized Care',
        description: 'For clients who desire the ultimate bespoke service, ReproCELL offers personal iPS exosome production using individual-derived cells, combining long-term health readiness with radically personalized treatment.'
      }
    ],
    image: '/Member Services/AESTHETICS & ANTI-AGING/body/2.png',
    imageAlt: 'Advanced technology'
  },
  whySectionC: {
    title: 'What Are iPS Cell Exosomes?',
    content: 'Exosomes are nanoscale vesicles secreted by cells that act as messengers, delivering vital proteins and genetic material to support rejuvenation, repair, and cell-to-cell communication. ReproCELL\'s iPS exosomes, derived using advanced mRNA methods for safety and purity, are superior to traditional stem cell sources—they display remarkable efficacy in promoting collagen synthesis, enhancing skin cell turnover, supporting vascular rejuvenation, and combating visible signs of aging.',
    image: '/Member Services/AESTHETICS & ANTI-AGING/body/3.png',
    imageAlt: 'iPS Cell Exosomes Technology'
  },
  masterpieceBackgroundImage: '/Member Services/AESTHETICS & ANTI-AGING/CTA Banner/banner.png'
}

export default function AestheticsAntiAgingPage() {
  return (
    <>
      <Helmet>
        <title>Aesthetics & Anti-Aging | Member Services | FGA Prestige</title>
        <meta name="description" content="Advanced anti-aging treatments with ReproCELL iPS cell-derived exosomes. Exclusive access to cutting-edge wellness and rejuvenation therapies at FGA Prestige." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/aesthetics-anti-aging" />
        <meta property="og:title" content="Aesthetics & Anti-Aging | Member Services | FGA Prestige" />
        <meta property="og:description" content="Advanced anti-aging treatments with ReproCELL iPS cell-derived exosomes. Exclusive access to cutting-edge wellness and rejuvenation therapies at FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/aesthetics-anti-aging" />
        <meta property="og:image" content="/Member Services/AESTHETICS & ANTI-AGING/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Aesthetics & Anti-Aging Services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aesthetics & Anti-Aging | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Advanced anti-aging treatments with ReproCELL iPS cell-derived exosomes. Exclusive access to cutting-edge wellness and rejuvenation therapies at FGA Prestige." />
        <meta name="twitter:image" content="/Member Services/AESTHETICS & ANTI-AGING/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Aesthetics & Anti-Aging",
            "description": "Advanced anti-aging treatments with ReproCELL iPS cell-derived exosomes. Exclusive access to cutting-edge wellness and rejuvenation therapies at FGA Prestige.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/aesthetics-anti-aging",
            "image": "/Member Services/AESTHETICS & ANTI-AGING/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={aestheticsConfig} />
    </>
  )
}